export const Signup = "/signup";
export const Login = "/login";
export const Dashboard = "/dashboard";
export const Locklist = "/locklist";
export const RecipientManagement = "/RecipientManagement";
export const ShareHistory = "/ShareHistory";
export const GrantAccess = "/GrantAccess";
export const GroupShare = "/GroupSharing";
export const RetractableAccess = "/RetractableAccess";
export const AuditTrail = "/audittrail";
export const AccountManagement = "/accountManagement";
// export const GroupManagement = "/groupManagement";
export const MemberManagement = "/memberManagement";
export const NotFound = "/notfound";
export const PageNotFound = "/404Error";
export const AuditTrailMapView = "/audittrailmapview";
export const PlanSubscription = "/plans";
export const SubscriptionPackageNew = "/package";
// export const SubscriptionPackageNew = "/packageNew";
export const PlanCustom = "/customPlans";
export const MultiApprove = "/multiApprove";
// export const SuperMultiApprove = "/superMultiApprove";
export const Tutorial = "/tutorial";
export const ContactUs = "/contactUs";
export const Setting = "/setting";
export const Logs = "/logs";

export const Test = "/Test";
